<template>
    <v-dialog v-model="deveMostrarModalInserirNovoReajuste" persistent max-width="300px">
        <v-card>
            <v-card-title class="modal-title primary py-1" primary-title>
                <span>Reajuste</span>
                <v-spacer></v-spacer>
                <v-btn small icon @click.stop="fecharModalInserirNovoReajuste">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap style="background-color: white;">
                        <v-flex xs12 sm12>
                            <v-select
                                v-model="value.anoBase"
                                label="Ano Base"
                                disabled
                                :items="[(new Date()).getFullYear()]"
                                name="Ano Base"
                                v-validate="'required'"
                                @change="value.anoIndicador = $event-1"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field
                                v-model="value.anoIndicador"
                                label="Ano Indicador"
                                disabled
                                readonly
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-select v-model="value.indicador"
                                      :items="['IPCA']"
                                      :menu-props="{ top: false, offsetY: true }"
                                      label="Indicador"/>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <campo-monetario
                                key="valorBase"
                                name="Valor Base"
                                v-model="value.valorBase"
                                label="Valor Base"
                                @blur="(valor) => value.valorBase = valor"
                                placeholder="Valor Base"
                                :maxLength="18"
                                :required="true"
                                :disabled="existeReajustesAnteriores"
                                :precision="2"
                                v-validate="'required|'"
                                :error-messages="errors.collect('Valor Base')"
                            />
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field v-model.number="value.percentualReajuste"
                                          placeholder="Exemplo: 10,50"
                                          name="Percentual Novo Reajuste"
                                          type="text"
                                          @input="value.percentualReajuste = $event.replace(',', '.')"
                                          min="0"
                                          class="required-field"
                                          key="Percentual-Novo-Reajuste"
                                          v-mask="['#,##', '##,##']"
                                          :rules="[v => !!v || 'Percentual Reajuste é obrigatório']"
                                          v-validate="'required|'"
                                          :error-messages="errors.collect('Percentual Novo Reajuste')"
                                          label="Percentual Reajuste">
                                <template v-slot:append>
                                    <v-icon color="primary">percent</v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions class="modal-actions pa-3">
                <v-btn flat outline color="botao-cancelar-color" @click.stop="fecharModalInserirNovoReajuste">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed @click.stop="validarNovoReajusteESalvar">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


</template>

<script>
export default {
    name: 'ModalInserirNovoReajuste',
    inject: ['$validator'],
    props: ['value', 'deveMostrarModalInserirNovoReajuste', 'historicoReajustes'],
    mounted() {
        this.setup()
    },
    computed: {
        existeReajustesAnteriores() {
            return this.historicoReajustes.length > 0
        }
    },
    methods: {
        async validarNovoReajusteESalvar() {
            const ehFormularioValido = await this.$validator.validate('Percentual Novo Reajuste')
            if(!ehFormularioValido)
                throw new Error('Preencha o percentual de reajuste')

            this.$emit('eventoSalvarNovoReajuste')
            this.resetValidation()
        },
        fecharModalInserirNovoReajuste() {
            this.resetValidation()
            this.$emit('fecharModalNovoReajuste')
        },
        resetValidation(){
            this.$validator.errors.clear()
            this.$validator.reset()
        },
        setup(){
            if(this.historicoReajustes.length > 0) {
                const primeiro = this.historicoReajustes[0]

                this.value.valorBase = primeiro.valorAtualizado

                if(this.value.anoBase !== primeiro.ano){
                    this.value.anoBase = primeiro.ano + 1
                    this.value.anoIndicador = primeiro.ano
                }
            }
        }
    },
    watch: {
        'historicoReajustes'(){
            this.setup()
        }
    }

}
</script>

<style scoped lang="stylus">

</style>